/**
 * analytics.jsx
 * -------------
 * Safe, best-effort push to window.dataLayer.
 *
 * Export
 * - pushDL(eventName, payload?)
 */

export function pushDL(eventName, payload = {}) {
  try {
    // Avoids crashes if dataLayer isn't defined by the host page.
    if (typeof window === "undefined") return;
    const w = window;
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({ event: eventName, ...payload });
  } catch {
    /* noop */
  }
}
